module.exports = __webpack_public_path__ + "img/services4.981d701c.jpg";